export default __webpack_public_path__ + "static/media/1824.e9450dd7.png";